import format from "../../../plugins/tmeforma";
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      bklist: [],
      CuInBk: false,
      //對話
      dialog: {
        chatlist: [],
        uploadData: {},
        chatInnertext: "",
        imgUrl: "",
      },
      dragOver: false,
      counter: 1,
    }
  },
  computed: {
    ...mapGetters(['fd'])
  },
  mounted () {
    this.getBlackList()
    this.$options.sockets.onmessage = (data) => {
      let skRes = JSON.parse(data.data)
      //公告訊息
      if (skRes.msgtype == 1) {
        if (skRes.sendmsg) {
          this.reply = skRes.sendmsg
          this.sendtime = skRes.sendtime
          let obj = {
            id: skRes.maid,
            nickname: skRes.nickname,
            time: this.sendtime,
            innertext: this.reply,
            roomcode: this.cu.roomcode,
            talktype: "0"
          }
          this.pushChatlist(obj)
        }
      }

      //接收訊息
      if (skRes.receiver == this.cu.roomcode) {
        if (skRes.sendmsg) {
          let obj = {
            id: skRes.userid,
            nickname: skRes.nickname,
            time: skRes.sendtime,
            innertext: skRes.sendmsg,
            roomcode: this.cu.roomcode,
            talktype: 0
          }
          this.pushChatlist(obj)
        }
      }
    }
  },
  methods: {
    ...mapActions(['setsecond']),
    //黑名單資料
    getBlackList (cuid) {
      this.$axios
        .bklist()
        .then(res => {
          this.bklist = res;
          if (cuid) {
            this.cuInBlackList(cuid)
          }
        })
        .catch(err => console.error(err));
    },
    //確認是否在黑名單中
    cuInBlackList (cuid) {
      let bk = this.bklist.filter(i => i.cuid === String(cuid))
      bk.length >= 1 ? this.CuInBk = true : this.CuInBk = false
    },
    //對話框滾輪最底部
    getMsg () {
      if (this.dialog.chatlist.length > 0) {
        let chatBlock = this.$el.querySelector("#chat_block")
        chatBlock.scrollTop = chatBlock.scrollHeight
      }
    },
    //上傳圖片前
    upImgBefore (file) {
      if (!this.checkfile(file)) return;
      this.dialog.uploadData = file
      const objectURL = URL.createObjectURL(file);
      this.dialog.imgUrl = objectURL
      return false
    },
    //手動上傳
    upimg () {
      var bodyFormData = new FormData();
      bodyFormData.append('imgname', this.username.maid);
      bodyFormData.append('img', this.dialog.uploadData);
      this.$axios.updateImage(bodyFormData)
        .then(res => {
          this.dialog.chatInnertext = `${process.env.VUE_APP_PICTURL}/${res[0].imgname}`
          this.sendmsg()
          this.dialog.imgUrl = '';
          this.dialog.chatInnertext = ''
        })
        .catch(err => console.error(err))
    },
    cancelubimg () {
      this.dialog.imgUrl = '';
    },
    checkfile (sender) {
      // 可接受的附檔名
      let validExts = new Array(".jpg", ".jpeg", ".png");
      let fileExt = sender.name;
      this.dragOver = false
      fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
      if (validExts.indexOf(fileExt) < 0) {
        this.$Message.error({
          content: '档案类型错误，可接受档案为：' + validExts.toString(),
          duration: 5
        });
        sender.value = null;
        return false;
      }
      else return true;
    },

    onDrop (e) {
      this.dialog.uploadData = e.dataTransfer.files[0]
      if (this.checkfile(this.dialog.uploadData)) this.upimg()
    },
    //找到搜尋的位置
    getSearchMsg (val) {
      let chatway = document.getElementsByClassName("chatway")
      let chatBlock = this.$el.querySelector("#chat_block")
      chatBlock.scrollTop = chatway[val].offsetTop - 100
    },
    //讯息送出
    sendmsg () {
      if (!((this.dialog.chatInnertext.trim()).length > 0)) return;
      let obj = {
        userid: Number(this.username.maid),
        innertext: this.dialog.chatInnertext,
        roomcode: this.cu.roomcode,
        userlv: this.username.lv,
        talktype: '0',
      }
      this.$axios.msgreco(obj)
        .then(res => {
          this.$axios.alreadyread({ rmcode: this.cu.roomcode, type: 1 })
        })
        .catch(err => console.error(err))

      let chalistobj = {
        id: Number(this.username.maid),
        nickname: this.username.nickname,
        time: format(new Date),
        innertext: this.dialog.chatInnertext,
        roomcode: this.cu.roomcode,
        talktype: 0,
      }
      if (!this.connect) {
        this.pushChatlist(chalistobj)
        this.dialog.chatInnertext = ''
        return;
      };
      if (this.connect) {
        this.$socket.sendObj({
          route: "msg",
          sender: this.fd,
          receiver: this.cu.roomcode,
          sendmsg: this.dialog.chatInnertext,
          userid: this.username.maid,
          nickname: this.username.nickname,
          sendtime: format(new Date),
        })
        this.setsecond(600)
      }
      this.dialog.chatInnertext = ''
    },

    //訊息放入陣列
    pushChatlist (obj) {
      new Promise((resolve, reject) => {
        this.dialog.chatlist.push(obj)
        resolve()
      })
        .then(res => this.getMsg())
    },
    //正則
    regex (string) {
      let standard1 = /^https\:\/\/pic\.gc16688\.net/;
      let standard2 = /^https\:\/\/gpic\.gc16688\.com/;
      let standard3 = /^https\:\/\/pic\.gc16688\.com/;
      let status = [standard1.test(string), standard2.test(string), standard3.test(string)].some(it => it)
      this.rwdImgStatus = status
      return status
    },
    //歷史訊息 
    history () {
      this.dialog.chatlist = []
      this.$axios.selmsg({
        type: 4,
        roomcode: this.cu.roomcode
      })
        .then(res => {
          if (res.length > 0) {
            res.forEach(i => {
              let obj = {
                id: i.userid,
                nickname: i.nickname,
                time: i.currtime,
                innertext: i.innertext,
                roomcode: i.sprmid,
                talktype: i.talktype
              }
              this.dialog.chatlist.push(obj)
            })
          }
        })
        .then(res => this.getMsg())
        .catch(err => console.error(err))
    },
    //搜尋位置
    getSearchMsg (val) {
      let chatway = document.getElementsByClassName("chatway")
      let chatBlock = this.$el.querySelector("#chat_block")
      chatBlock.scrollTop = chatway[val].offsetTop - 100
    },
    dragover (ev) {
      ev.preventDefault();
      this.dragOver = true;
    },
    dragleave (ev) {
      // ev.preventDefault();
      this.dragOver = false
    },
  },
}